


import * as ProgressPrimitive from "@radix-ui/react-progress"
import { cn } from "../../shared/utils"



const Progress = (({ className, value, ...props }) => (
  <ProgressPrimitive.Root
    // ref={ref}
    className={cn(
      "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
      className
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 bg-secondary transition-all"
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
